import React, { Fragment, useState, useEffect } from 'react';
import Sticky from 'react-stickynode';
import { ThemeProvider } from 'styled-components';
import { Modal } from '@redq/reuse-modal';
import { agencyTheme } from 'common/src/theme/agency';
import { ResetCSS } from 'common/src/assets/css/style';
import {
  GlobalStyle,
  AgencyWrapper,
  ConditionWrapper,
} from '../containers/Agency/agency.style';
import Navbar from '../containers/Agency/Navbar';
import BannerSection from '../containers/Agency/BannerSection';
import FeatureSection from '../containers/Agency/FeatureSection';
import AboutWizySection from '../containers/Agency/AboutWizySection';
import WorkHistory from '../containers/Agency/WorkHistory';
import BlogSection from '../containers/Agency/BlogSection';
import TeamSection from '../containers/Agency/TeamSection';
import Footer from '../containers/Agency/Footer';
import Gallery from '../containers/Agency/Gallery';
import { DrawerProvider } from 'common/src/contexts/DrawerContext';
import '@redq/reuse-modal/es/index.css';
import SEO from '../components/seo';

import WizyEMMSection from '../containers/Agency/WizyEMMSection';
import WizyVisionSection from '../containers/Agency/WizyVisionSection';
// import FrontspaceSection from '../containers/Agency/FrontspaceSection';
// import FrontspaceSectionTwo from '../containers/Agency/FrontspaceSectionTwo';
function getSize() {
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth,
  };
}

function useWindowSize() {
  let [windowSize, setWindowSize] = useState(getSize());

  function handleResize() {
    setWindowSize(getSize());
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
}

export default () => {
  const size = process.browser && useWindowSize();
  return (
    <ThemeProvider theme={agencyTheme}>
      <Fragment>
        <SEO
          title="Wizy.io Startup Studio"
          description="We build Digital Solutions that Frontline Workers love."
          keywords={[
            'google',
            'gcp',
            'android',
            'mdm',
            'emm',
            'artificial intelligence',
            'ai',
            'frontline',
            'mobile management',
            'digital assets',
            'machine learning',
          ]}
        />
        <Modal />
        <ResetCSS />
        <GlobalStyle />
        {/* End of agency head section */}
        {/* Start agency wrapper section */}
        <AgencyWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <BannerSection />
          <BlogSection />
          <WizyEMMSection />
          <WizyVisionSection />
          {/* <ConditionWrapper id="keyfrontspace">
            {size && size.innerWidth < 1100 ? (
              <FrontspaceSectionTwo />
            ) : (
              <FrontspaceSection />
            )}
          </ConditionWrapper> */}

          <FeatureSection />
          <WorkHistory />
          <Gallery />
          <AboutWizySection />
          <TeamSection />
          <Footer />
        </AgencyWrapper>
        {/* End of agency wrapper section */}
      </Fragment>
    </ThemeProvider>
  );
};
